import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=3f4067b3&"
import script from "./Mark.vue?vue&type=script&lang=js&"
export * from "./Mark.vue?vue&type=script&lang=js&"
import style0 from "./Mark.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports